import {useCallback} from 'react';
import {useRouter} from 'next/router';

import {Button, Link, Text} from '#component/base';
import {ModalRoot, ModalTrigger} from '#component/base/Modal';
import {KitRegistrationInstructionModal} from '#component/modal';
import {ProgressTracker} from '#component/partial';
import {sprinkles} from '#style/sprinkles';

import {StepProps} from '../../Register.types';
import {RegistrationStep} from '../RegistrationStep';
import {RegistrationStepBox} from '../RegistrationStepBox';

export const StepSummary = ({className}: StepProps) => {
  const {replace} = useRouter();

  const handleGoToSurvey = useCallback(() => {
    replace('/survey');
  }, [replace]);

  return (
    <ModalRoot>
      <RegistrationStep
        className={className}
        nextText="I’ve Taken My Test"
        prevText="View Test Instructions"
        onNext={handleGoToSurvey}
        renderPrev={text => (
          <Button
            as={ModalTrigger}
            variant="secondary-dark"
            className={sprinkles({order: [2, 1, 1]})}>
            {text}
          </Button>
        )}>
        <div
          className={sprinkles({
            flex: 'flex',
            dir: 'col',
            content: 'between',
            gap: [32, 48, 64],
            marginBottom: [0, 0, 72],
          })}>
          <div
            className={sprinkles({
              flex: 'flex',
              dir: 'col',
              content: 'between',
              gap: [16, 24, 24],
            })}>
            <Text as="h2" color="cotton" variant="heading2">
              Your test kit is now registered
            </Text>
            <Text as="p" color="springWood">
              Here’s what to do next:
            </Text>
          </div>
          <RegistrationStepBox>
            <ProgressTracker
              className={sprinkles({m: [24, 40, 40]})}
              currentItemIndex={1}
              currentItemStatus="in-progress"
              items={[
                {title: 'Test kit registered'},
                {
                  title: 'Take your swab test',
                  subtitle: (
                    <>
                      {'Follow the '}
                      <Link as={ModalTrigger} color="doveGray" variant="caption">
                        instructions
                      </Link>
                      {' carefully to ensure an accurate result.'}
                    </>
                  ),
                },
                {title: 'Take your Lifestyle Survey'},
                {title: 'Mail your sample via USPS'},
                {title: 'Receive your TallyAge™ results '},
              ]}
            />
          </RegistrationStepBox>
        </div>
        <KitRegistrationInstructionModal />
      </RegistrationStep>
    </ModalRoot>
  );
};
